import {Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import {RightSideService} from '../shared/right-side.service';
import {NavigationBarService} from '../shared/navigation-bar.service';
import {PageContent} from '../shared/classes/page-content.model';
import {Category} from '../shared/classes/category.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
  // @todo delete this
  // @Output() changeCategory: EventEmitter<Category> = new EventEmitter<Category>();
  categoryName: string;
  pageContent: PageContent;
  selectedTab: number;

  constructor(private tabsService: RightSideService,
              private rightSideService: RightSideService,
              private navBarService: NavigationBarService) {

    this.tabsService.categoryNameChange.subscribe(val => {
      this.categoryName = this.tabsService.getCategoryName();
    });

    this.navBarService.selectedTabChange.subscribe(val => {
      this.selectedTab = this.navBarService.getSelectedTab();
    });

    this.rightSideService.pageContentChange.subscribe(val => {
      this.pageContent = this.rightSideService.getPageContent();
    });
  }

  ngOnInit() {
  }

  /* @todo delete this
  clickCategory(category: Category) {
    this.changeCategory.emit(category);
  }*/

  clickMobilButton(type: string) {
    const firstButton = $('.how-to-process-mobil-heading .coupon-title');
    const secondButton = $('.how-to-process-mobil-heading .cashback-title');

    const firstTab = $('#how-to-process-col-first');
    const secondTab = $('#how-to-process-col-second');
    if (type === 'coupon') {
      firstTab.show();
      secondTab.hide();
      firstButton.addClass('active');
      secondButton.removeClass('active');
    } else {
      firstTab.hide();
      secondTab.show();
      firstButton.removeClass('active');
      secondButton.addClass('active');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/footer/footer.component.ts